import axios from "axios";
import { CandidateCorpModel, _CandidateCorpAPIModel_ } from "models";
import { IAPIResult } from "models/interfaces";

export async function list(): Promise<IAPIResult<CandidateCorpModel[]>> {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<_CandidateCorpAPIModel_[]>>(
    "/api.d/v1/ec/candidate-corp/list"
  );
  const data = response.data.data.map((v) => {
    const tmp: CandidateCorpModel = {
      corp_id: v.candidate_corp_id,
      corp_name: v.corp_name,
      logo_image: v.logo_image,
      introduction: v.introduction,
      corp_tag_list: v.corp_tag_list ?? [],
    };
    return tmp;
  });

  return {
    data,
    error: response.data.error,
  };
}

export async function add(candidate_corp_id: string): Promise<IAPIResult> {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/candidate-corp/create",
    { candidate_corp_id }
  );
  return response.data;
}

export async function del(candidate_corp_id: string): Promise<IAPIResult> {
  // await Utils.sleep(300);
  const response = await axios.delete<IAPIResult>(
    "/api.d/v1/ec/candidate-corp/delete",
    { data: { candidate_corp_id } }
  );
  return response.data;
}
